<template>
  <div>
    <div id="form-container" class="custom-wrapper">
      <div class="row container body-text text-center">
        <h1>Indoor Cannabis Cultivator Energy Use Estimator</h1>
        <p>Use this calculator, along with any other relevant information, to estimate your energy usage to report on your OLCC permit application.  This calculator is meant to provide an approximation of your energy usage.  Actual electricity usage may vary and is dependent upon your specific operations. <br><br>Please contact the Oregon Department of Energy at <a href="tel:5033784040">(503) 378-4040</a> if you have any questions or need additional assistance in estimating your energy usage. </p>
      </div>
      <!-- Make sure to change the successRedirect URL when pushing to production. -->
      <form class="formView socrataForm commonForm" method="POST"
            data-defaultSuccessRedirect="https://data.oregon.gov/Natural-Resources/Cannabis-Energy-Use-Calculator/mixr-uurk/form_success"
            action="https://data.oregon.gov/views/mixr-uurk/rows.html?method=createForm&successRedirect=https%3A%2F%2Fenergy.odoe.state.or.us%2Fthankyou" _lpchecked="1">
        <div class="row">
          <div class="form-group col-md-6 custom-form">
            <!-- Cultivator Name -->
            <label>Cultivator Name</label>
            <input id="form_field_cultivator_name" name="cultivator_name" type="text" class="form-control" v-model="cultivatorName">

            <label>Estimated total grow area (sq. ft.)</label>
            <input id="form_field_estimated_total_grow_area" name="estimated_total_grow_area" type="number" class="form-control" v-model="estTotalGrowArea">


            <label>Estimated total plants in continuous grow</label>
            <input id="form_field_plants" name="plants" type="number" class="form-control" min="0" v-model="estTotalPlants">

            <label>Actual energy use, if known (kWh / yr)</label>
            <input id="form_field_actual_energy_use" name="actual_energy_use" type="number" class="form-control" v-model="actualEnergyUse">

            <label for="">Select the Energy Use Equipment Description that best describes your operation: <a id="description_modal_link" data-toggle="modal" data-target="#description_modal"><span class="badge badge-secondary">?</span></a></label>
            <select id="form_field_energy_use_option" name="energy_use_option" class="form-control" v-model="selected">
              <option value="none"></option>
              <option value="zut5-bgwp">1</option>
              <option value="wdrt-qd47">2</option>
              <option value="h7h7-pebf">3</option>
              <option value="d2a2-t4vd">4</option>
            </select>
          </div>
          <div class="col-md-6">
            <!-- Card Display -->
            <div class="data-display">
              <div class="row">
                <div class="custom-card text-center">
                  <!-- Custom Card Width: 250px-->
                  <div>
                    <h4>{{ monthly_energy_use_option_selector | numbers }}</h4>
                    <p class="card-text">kWh per month<br /> Estimated Monthly Energy Use</p>
                  </div>
                </div>
                <div class="custom-card text-center">
                  <div>
                    <h4>{{ annual_energy_use_option_selector | numbers }}</h4>
                    <p class="card-text">kWh per year<br /> Estimated Annual Energy Use</p>
                  </div>
                </div>
              </div>
      
      <div class="row">
        <div class="gradient-container">
          <div class="gradient-background">
            <div class="gradient-subcontainer">
              <span class="gradient-text">
                {{ estimated_energy_usage_low | numbers }} kWh<br>
                <span class="gradient-subtext">Low Energy Use Estimate</span>
              </span>
            </div>
            <!-- Used an empty div for CSS Grid layout purposes -->
            <div class="gradient-subcontainer"></div>
            <div class="gradient-subcontainer">
              <span class="gradient-text">
                {{ estimated_energy_usage_high | numbers }} kWh <br>
                <span class="gradient-subtext">High Energy Use Estimate</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="gradient-container">
          <div class="gradient-background">
            <div class="gradient-subcontainer">
              <span class="gradient-text">
                ${{ estimated_annual_electricity_cost_low | numbers }}<br>
                <span class="gradient-subtext">Low Energy Cost Estimate</span><br>
              </span>
            </div>
            <!-- Used an empty div for CSS Grid layout purposes -->
            <div class="gradient-subcontainer"></div>
            <div class="gradient-subcontainer">
              <span class="gradient-text">
                ${{ estimated_annual_electricity_cost_high | numbers }}<br>
                <span class="gradient-subtext">High Energy Cost Estimate</span><br>
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- End Card Display -->
  </div>
  </div>

  <!--Hidden Fields-->
  <div class="hideme">
    <div class="row">
      <!-- Estimated Monthly Energy Use -->
    
      <!-- End Estimated Monthly Energy Use -->
      <!-- Estimated Annual Energy Use -->
      <div class="form-group col-md-6">
        <!-- use d-none class if you want to hide it-->
        <label for="">Estimated <span class="annual">Annual</span> Energy Use (kWh / yr)</label>
        <input id="form_field_predicted_energy_usage" name="predicted_energy_usage" type="text" class="form-control" v-model="annual_energy_use_option_selector" readonly>
      </div>
      <!-- End Estimated Annual Energy Use -->
    </div>

    <div class="row">
      <!-- Estimated Energy Usage Low -->
      <div class="form-group col-md-6">
        <!-- use d-none class if you want to hide it-->
        <label for="form_field_estimated_energy_use_low">Estimated Energy Use Low</label>
        <input id="form_field_estimated_energy_use_low" name="estimated_energy_use_low" type="text" class="form-control" v-model="estimated_energy_usage_low" readonly>
      </div>
      <!-- End Estimated Energy Usage Low -->
      <!-- Estimated Energy Usage High -->
      <div class="form-group col-md-6">
        <!-- use d-none class if you want to hide it-->
        <label for="form_field_estimated_energy_use_high">Estimated Energy Use High</label>
        <input id="form_field_estimated_energy_use_high" name="estimated_energy_use_high" type="text" class="form-control" v-model="estimated_energy_usage_high" readonly>
      </div>
      <!-- End Estimated Energy Usage High -->
    </div>
    <div class="row">
      <!-- Estimated Annual Electricity Cost Low -->
      <div class="form-group col-md-6">
        <!-- use d-none class if you want to hide it-->
        <label for="">Estimated Annual Electricity Cost Low</label>
        <input id="form_field_estimated_annual_electricity_cost_low" name="estimated_annual_electricity_cost_low" type="text" class="form-control" v-model="estimated_annual_electricity_cost_low" readonly>
      </div>
      <!-- End Estimated Annual Electricity Cost Low -->
      <!-- Estimated Annual Electricity Cost High -->
      <div class="form-group col-md-6">
        <!-- use d-none class if you want to hide it-->
        <label for="">Estimated Annual Electricity Cost High</label>
        <input id="form_field_estimated_annual_electricity_cost_high" name="estimated_annual_electricity_cost_high" type="text" class="form-control" v-model="estimated_annual_electricity_cost_high" readonly>
      </div>
      <!-- End Estimated Annual Electricity Cost High -->
    </div>
  </div>
  <!-- End Hidden Fields -->
  <div class="row custom-buttons container">
    <input type="submit" class="btn btn-primary btn-lg btn-block" value="Submit Usage" v-on:click="cookieSetter">
  </div>

  </div></form>
  <!-- Modal -->
  <div class="modal fade" id="description_modal" tabindex="-1" role="dialog" aria-labelledby="descriptionModalTrue" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="descriptionModalTrue">Energy Use Equipment Description</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <table class="table-striped">
            <thead>
              <tr>
                <th scope="col" class="classification">Option Number</th>
                <th scope="col">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="classification">#1</td>
                <td>Low energy usage. Use low wattage LED and CFL lighting, low light fixture density (greater than 60 sq. ft. per light).  No supplemental cooling or heating to grow space.  No mechanical ventilation and air circulation.  No dehumidification, pumping, CO2 production, or additional energy usages.</td>
              </tr>
              <tr>
                <td class="classification">#2</td>
                <td>Medium-Low energy usage. High wattage HID fixtures at low light fixture density (greater than 60 sq. ft. per light).  Very minimal or no supplemental cooling or heating to grow space.  Minimal mechanical ventilation and air circulation (ventilation only used minimally and not continuously to control temperature). No dehumidification, pumping, CO2 production, or additional energy usages.</td>
              </tr>
              <tr>
                <td class="classification">#3</td>
                <td>Medium-high energy usage. High wattage HID fixtures with medium light density (40 - 60 sq. ft. per light).   Significant supplemental cooling and/or heating to grow space.  High-volume ventilation and air circulation that is frequently on.  Minimal dehumidification, pumping, CO2 production, or additional energy usages.</td>
              </tr>
              <tr>
                <td class="classification">#4</td>
                <td>High energy usage. High wattage HID fixtures, unvented, high light density (less than 40 sq. ft. per light).  Significant supplemental cooling and/or heating to grow space.  High volume ventilation and air circulation (high level of air changes) that operates majority of the time.  Multiple other energy using equipment, including dehumidification, pumping and water temperature control, CO2 production, etc.</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <strong>NOTE:</strong> Calculations assume typical 12-18 hour per day light operation for vegetative and flowering phases and a continous grow cycle.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Modal -->
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {
      selected: '',
      cultivatorName: '',
      estTotalGrowArea: null,
      estTotalPlants: null,
      actualEnergyUse: null,
    }
  },
  methods: {
    cookieSetter: function() {
      // Cookie name, value, timeframe
      this.$cookies.set("cultivatorName", this.$data.cultivatorName, "1D");
      this.$cookies.set("estTotalGrowArea", this.$data.estTotalGrowArea, "1D");
      this.$cookies.set("estTotalPlants", this.$data.estTotalPlants, "1D");
      this.$cookies.set("actualEnergyUse", this.$data.actualEnergyUse, "1D");
      this.$cookies.set("estimatedEnergyUsageLow", this.estimated_energy_usage_low, "1D");
      this.$cookies.set("estimatedEnergyUsageHigh", this.estimated_energy_usage_high, "1D");
      this.$cookies.set("estimatedAnnualElecCostLow", this.estimated_annual_electricity_cost_low, "1D");
      this.$cookies.set("estimatedAnnualElecCostHigh", this.estimated_annual_electricity_cost_high, "1D");
      this.$cookies.set("annualEnergyUseSelector", this.annual_energy_use_option_selector, "1D");
      this.$cookies.set("monthlyEnergyUseSelector", this.monthly_energy_use_option_selector, "1D");

      if (this.selected === "zut5-bgwp"){
        this.$cookies.set("energyUseEquipmentDesc", "Low energy usage: Use low wattage LED and CFL lighting, low light fixture density (greater than 60 sq. ft. per light).  No supplemental cooling or heating to grow space.  No mechanical ventilation and air circulation.  No dehumidification, pumping, CO2 production, or additional energy usages.", "1D");
      } else if (this.selected === "wdrt-qd47") {
        this.$cookies.set("energyUseEquipmentDesc", "Medium-Low energy usage: High wattage HID fixtures at low light fixture density (greater than 60 sq. ft. per light).  Very minimal or no supplemental cooling or heating to grow space.  Minimal mechanical ventilation and air circulation (ventilation only used minimally and not continuously to control temperature). No dehumidification, pumping, CO2 production, or additional energy usages.", "1D");
      } else if (this.selected === "h7h7-pebf") {
        this.$cookies.set("energyUseEquipmentDesc", "Medium-high energy usage: High wattage HID fixtures with medium light density (40 - 60 sq. ft. per light).   Significant supplemental cooling and/or heating to grow space.  High-volume ventilation and air circulation that is frequently on.  Minimal dehumidification, pumping, CO2 production, or additional energy usages.", "1D");
      } else if (this.selected === "d2a2-t4vd") {
        this.$cookies.set("energyUseEquipmentDesc", "High energy usage:  High wattage HID fixtures, unvented, high light density (less than 40 sq. ft. per light).  Significant supplemental cooling and/or heating to grow space.  High volume ventilation and air circulation (high level of air changes) that operates majority of the time.  Multiple other energy using equipment, including dehumidification, pumping and water temperature control, CO2 production, etc.", "1D");
      } else {
        this.$cookies.set("energyUseEquipmentDesc", "Not Selected", "1D")
      }
    }
  },
  computed: {
    estimated_energy_usage_low: function () {
      return Math.round(this.estTotalGrowArea * 20);
    },
    estimated_energy_usage_high: function () {
      return Math.round(this.estTotalGrowArea * 200);
    },
    estimated_annual_electricity_cost_low: function () {
      return Math.round(this.estTotalGrowArea * 0.1 * 20);
    },
    estimated_annual_electricity_cost_high: function () {
      return Math.round(this.estTotalGrowArea * 0.1 * 200);
    },
    annual_energy_use_option_selector: function () {
      if (this.selected === "none") {
        return 0;
      } else if (this.selected === "zut5-bgwp") {
          return Math.round(this.estTotalGrowArea * 20);
      } else if (this.selected === "wdrt-qd47") {
          return Math.round(this.estTotalGrowArea * 20 * 4);
      } else if (this.selected === "h7h7-pebf") {
          return Math.round(this.estTotalGrowArea * 20 * 7);
      } else if (this.selected === "d2a2-t4vd") {
          return Math.round(this.estTotalGrowArea * 20 * 10);
      }
    },
    monthly_energy_use_option_selector: function () {
      if (this.selected === "none") {
        return 0;
      } else if (this.selected === "zut5-bgwp") {
          return Math.round((this.estTotalGrowArea * 20) / 12);
      } else if (this.selected === "wdrt-qd47") {
          return Math.round((this.estTotalGrowArea * 20 * 4) / 12);
      } else if (this.selected === "h7h7-pebf") {
          return Math.round((this.estTotalGrowArea * 20 * 7) / 12);
      } else if (this.selected === "d2a2-t4vd") {
          return Math.round((this.estTotalGrowArea * 20 * 10) / 12);
      }
    }
  },
  filters: {
    numbers: function (value) {
      if (value === undefined) {
        return 0;
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
}
</script>

<style>
  body, html {
    height: 100%;
    margin: 0;
    background-color: #93a1be;
  }

  .hero {
    padding-top: 75px;
  }

  .body-text {
    font-weight: 300;
    color: lightgrey;
    padding: 20px;
    margin: 0 auto;
  }

  .body-text h1 {
    margin: 0 auto;
  }

  #app {
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #ffffff;
    margin: 0 auto;
  }

  #main_img {
    max-width: 100%;
  }

  h1, h2 {
    font-weight: 300;
    padding: 20px;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  label {
    margin-top: 10px;
    font-weight: 300;
  }

  .classification {
    width: 10%;
    text-align: center;
  }

  .hideme {
    display: none;
  }

  .data-display {
    padding-top: 20px;
    padding-bottom: 21px;
    margin-top: 20px;
  }

  .custom-wrapper {
    width: 90%;
    margin: 0 auto;
    background-color: #00395e;
    padding: 30px;
    border-radius: 5px;
    opacity: 0.95;
  }

  .custom-card {
    width: 250px;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 10px;
    padding: 10px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    border-radius: 5px;
    background-color: #4c7636;
  }

  .custom-card:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.6);
  }

  .custom-form {
    margin-top: 10px;
    text-align: left;
  }

  .modal-content {
    color: black;
  }

   #description_modal_link {
    cursor: pointer;
  }

  .bg-dark {
    background-color: #00395e;
  }

  .custom-buttons {
    margin: 0 auto;
  }

  .custom-buttons button {
    margin: 10px;
  }

  button.btn.btn-lg {
    padding: 20px;
  }

  .gradient-container {
    margin: auto;
    width: 83%;
  }

  .gradient-background {
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#21a529+0,e0772c+100 */
    background: #21a529; /* Old browsers */
    background: -moz-linear-gradient(left, #21a529 0%, #e0772c 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, #21a529 0%,#e0772c 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, #21a529 0%,#e0772c 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#21a529', endColorstr='#e0772c',GradientType=1 ); /* IE6-9 */
    margin: auto;
    margin-top: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
    width: 100%;
    height: 100px;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-flow: row wrap;
    justify-content: space-around;
  }

  .gradient-background div {
    padding: 5px;
    font-size: 15px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 10px;
    text-align: center;
  }

  .gradient-text {
    font-weight: 300;
    font-size: 13px;
  }

  /* MEDIA QUERIES */

  @media only screen and (max-width: 600px) {
    .gradient-subtext {
      display: none;
    }

    .gradient-background div {
      margin-top: 35px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue